/* KAMOK PRODUCT COMPARE V2 | product descriptions, dynamic specifications, variant prices, and Shopify cart */
(() => {
  "use strict";
  if (window.KamokCompareV1) return;
  window.KamokCompareV1 = true;
  const KEY = "kamok_compare_v1", MAX = 4;
  let selected = [], tray = null, dialog = null, timeout = null, onlyDifferences = false, loadingSerial = 0;
  const variantsByHandle = new Map(), productCache = new Map();
  const mk = (tag, cls, content) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (content !== undefined) node.textContent = String(content);
    return node;
  };
  const root = () => window.Shopify?.routes?.root || "/";
  const productUrl = handle => root() + "products/" + encodeURIComponent(handle);
  const clean = value => String(value ?? "").replace(/\s+/g, " ").trim();
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(selected)); } catch (_) {} };
  try {
    const persisted = JSON.parse(localStorage.getItem(KEY) || "[]");
    if (Array.isArray(persisted)) selected = [...new Set(persisted.filter(h => typeof h === "string" && /^[a-z0-9-]{1,120}$/i.test(h)))].slice(0, MAX);
  } catch (_) {}
  const getHandle = value => {
    try {
      const url = new URL(value, location.href);
      const path = url.pathname.split("/").filter(Boolean);
      const index = path.indexOf("products");
      return url.origin === location.origin && index !== -1 && /^[a-z0-9-]{1,120}$/i.test(path[index + 1] || "") ? path[index + 1] : null;
    } catch (_) { return null; }
  };
  function updateButtons() {
    document.querySelectorAll("[data-kmcompare-handle]").forEach(button => {
      const chosen = selected.includes(button.dataset.kmcompareHandle);
      button.setAttribute("aria-pressed", chosen ? "true" : "false");
      button.textContent = chosen ? "✓ Palyginimui pridėta" : "⚖ Palyginti";
    });
  }
  function toggle(handle) {
    if (selected.includes(handle)) selected = selected.filter(h => h !== handle);
    else if (selected.length < MAX) selected.push(handle);
    else { alert("Galima palyginti iki 4 prekių."); return; }
    save(); renderTray(); updateButtons();
    if (dialog?.open && selected.length === 0) dialog.close();
  }
  function makeSelectButton(handle, large) {
    const button = mk("button", "kmcompare-button" + (large ? " kmcompare-large" : ""), "⚖ Palyginti");
    button.type = "button";
    button.dataset.kmcompareHandle = handle;
    button.addEventListener("click", event => { event.preventDefault(); event.stopPropagation(); toggle(handle); });
    return button;
  }
  function scanCards() {
    document.querySelectorAll(".card-wrapper,.product-card-wrapper,.km-floor-card,[data-product-card]").forEach(card => {
      if (card.dataset.kmcompareDone) return;
      const link = card.querySelector('a[href*="/products/"]');
      const handle = link ? getHandle(link.href) : null;
      if (!handle) return;
      (card.querySelector(".card__information") || card.querySelector(".card__content") || card).appendChild(makeSelectButton(handle, false));
      card.dataset.kmcompareDone = "1";
    });
    document.querySelectorAll("product-info[data-url]").forEach(info => {
      if (info.dataset.kmcompareDone) return;
      const handle = getHandle(info.dataset.url);
      if (!handle) return;
      const button = makeSelectButton(handle, true);
      const form = info.querySelector(".product-form__buttons");
      if (form) form.insertAdjacentElement("afterend", button);
      else (info.querySelector(".product__info-container") || info).appendChild(button);
      info.dataset.kmcompareDone = "1";
    });
    updateButtons();
  }
  function renderTray() {
    if (!tray) {
      tray = mk("aside", "kmcompare-tray");
      tray.setAttribute("aria-label", "Prekių palyginimas");
      document.body.appendChild(tray);
    }
    tray.replaceChildren();
    tray.hidden = selected.length === 0;
    if (tray.hidden) return;
    tray.appendChild(mk("strong", "", "Palyginimui: " + selected.length + "/" + MAX));
    const compare = mk("button", "kmcompare-primary", "Palyginti prekes");
    compare.type = "button"; compare.addEventListener("click", openCompare);
    const clear = mk("button", "kmcompare-clear", "Išvalyti");
    clear.type = "button";
    clear.addEventListener("click", () => { selected = []; variantsByHandle.clear(); save(); renderTray(); updateButtons(); if (dialog?.open) dialog.close(); });
    tray.append(compare, clear);
  }
  function getDialog() {
    if (dialog) return dialog;
    dialog = mk("dialog", "kmcompare-dialog");
    dialog.setAttribute("aria-label", "Prekių palyginimas");
    dialog.addEventListener("click", event => { if (event.target === dialog) dialog.close(); });
    document.body.appendChild(dialog);
    return dialog;
  }
  function money(cents) {
    if (cents === null || cents === undefined || !Number.isFinite(Number(cents))) return "—";
    try {
      return new Intl.NumberFormat("lt-LT", { style: "currency", currency: window.Shopify?.currency?.active || "EUR" }).format(Number(cents) / 100);
    } catch (_) { return (Number(cents) / 100).toFixed(2) + " €"; }
  }
  async function loadProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    try {
      const response = await fetch(productUrl(handle) + ".js", { credentials: "same-origin", headers: { Accept: "application/json" } });
      if (!response.ok) throw new Error(String(response.status));
      const product = await response.json();
      if (!product || !Array.isArray(product.variants)) throw new Error("INVALID_PRODUCT");
      product.handle = handle;
      productCache.set(handle, product);
      return product;
    } catch (_) { return null; }
  }
  function getVariant(p) {
    const candidates = p.variants || [];
    const saved = variantsByHandle.get(p.handle);
    const found = candidates.find(v => String(v.id) === String(saved));
    const chosen = found || candidates.find(v => v.available) || candidates[0] || null;
    if (chosen?.id) variantsByHandle.set(p.handle, chosen.id);
    return chosen;
  }
  function variantTitle(v) {
    const title = clean(v?.public_title || v?.title || "");
    return !title || /^default title$/i.test(title) ? "Standartinis" : title;
  }
  function imageOf(p) {
    const image = p.featured_image || p.images?.[0];
    return typeof image === "string" ? image : image?.src || image?.url || "";
  }
  function isRental(p, v) {
    return /(^|[-\s])nuoma($|[-\s])|rental/i.test(p.handle + " " + p.title) || v?.requires_selling_plan === true;
  }
  async function addProduct(product, button) {
    const variant = getVariant(product);
    if (isRental(product, variant)) { location.assign(productUrl(product.handle)); return; }
    if (!variant?.available || !variant.id) {
      button.textContent = "Negalima užsakyti";
      return;
    }
    button.disabled = true;
    button.textContent = "Pridedama…";
    let added = false;
    try {
      const response = await fetch(root() + "cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          id: variant.id, quantity: 1,
          sections: ["cart-drawer", "cart-icon-bubble"],
          sections_url: location.pathname
        })
      });
      const data = await response.json();
      if (!response.ok || data.status === 422) throw new Error(data.description || "CART_ADD_FAILED");
      added = true;
      if (dialog?.open) dialog.close();
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      const drawer = document.querySelector("cart-drawer");
      if (drawer && typeof drawer.renderContents === "function" && data.sections?.["cart-drawer"] && data.sections?.["cart-icon-bubble"]) {
        try {
          drawer.renderContents(data);
          window.dispatchEvent(new CustomEvent("kamok:cart-updated"));
        } catch (_) { location.reload(); }
      } else { location.reload(); }
    } catch (_) {
      if (added) { location.reload(); return; }
      button.disabled = false;
      button.textContent = "Bandyti dar kartą";
    }
  }
  function parseDescription(p) {
    const html = typeof p.description === "string" ? p.description : "";
    const specs = new Map();
    let text = "";
    try {
      const doc = new DOMParser().parseFromString(html, "text/html");
      doc.querySelectorAll("script,style,noscript,svg,iframe").forEach(n => n.remove());
      text = clean(doc.body?.textContent || "");
      const insert = (key, value) => {
        const k = clean(key).replace(/:$/, ""), v = clean(value);
        if (k.length < 3 || k.length > 65 || !v || v.length > 220 || specs.size >= 60) return;
        const normalized = k.toLocaleLowerCase("lt-LT");
        if (!specs.has(normalized)) specs.set(normalized, { label: k, value: v });
      };
      doc.querySelectorAll("tr").forEach(tr => {
        const cells = [...tr.children].filter(n => ["TH","TD"].includes(n.tagName));
        if (cells.length >= 2) insert(cells[0].textContent, cells.slice(1).map(n => n.textContent).join(" "));
      });
      doc.querySelectorAll("dt").forEach(dt => {
        let dd = dt.nextElementSibling;
        if (dd?.tagName === "DD") insert(dt.textContent, dd.textContent);
      });
      doc.querySelectorAll("li,p").forEach(node => {
        if (node.querySelector("table,ul,ol")) return;
        const raw = clean(node.textContent);
        const split = raw.indexOf(":");
        if (split > 2 && split < 65 && raw.length - split <= 220) insert(raw.slice(0,split), raw.slice(split+1));
      });
    } catch (_) { text = clean(html.replace(/<[^>]*>/g, " ")); }
    return { text, specs };
  }
  function detailsContent(text) {
    const span = mk("div", "kmcompare-description");
    if (!text) { span.textContent = "Aprašymas nepateiktas"; return span; }
    if (text.length <= 340) { span.textContent = text; return span; }
    span.appendChild(mk("p", "kmcompare-description-preview", text.slice(0, 310).replace(/\s+\S*$/, "") + "…"));
    const details = mk("details", "kmcompare-details");
    details.append(mk("summary", "", "Skaityti visą aprašymą"), mk("div", "kmcompare-full-description", text));
    span.appendChild(details);
    return span;
  }
  function rowsFor(products) {
    const descriptions = products.map(parseDescription);
    const variants = products.map(getVariant);
    const cell = (label, getter) => ({
      label,
      values: products.map((p,i) => {
        const value = getter(p, variants[i], i);
        return value === null || value === undefined || value === "" ? "—" : String(value);
      })
    });
    const rows = [
      cell("Kaina", (p,v) => money(v?.price ?? p.price)),
      cell("Sena kaina", (p,v) => Number(v?.compare_at_price) > Number(v?.price) ? money(v.compare_at_price) : "—"),
      cell("Galima užsakyti", (p,v) => v?.available ? "Taip" : "Ne"),
      cell("Gamintojas", p => p.vendor),
      cell("Kategorija", p => p.type || p.product_type),
      cell("Pasirinktas variantas", (p,v) => variantTitle(v)),
      cell("Prekės kodas (SKU)", (p,v) => v?.sku),
      cell("Barkodas (EAN / GTIN)", (p,v) => v?.barcode),
      cell("Svoris", (p,v) => v?.grams > 0 ? (v.grams >= 1000 ? (v.grams / 1000).toLocaleString("lt-LT")+" kg" : v.grams+" g") : "—")
    ];
    const optionLabels = new Map();
    products.forEach(p => (p.options || []).forEach((option,i) => {
      const label = typeof option === "string" ? option : option?.name;
      if (label && !/^title$/i.test(label)) optionLabels.set(clean(label).toLocaleLowerCase("lt-LT"), { label: clean(label), index: i });
    }));
    for (const [, meta] of optionLabels) {
      rows.push(cell(meta.label, (p,v) => {
        const idx = (p.options || []).findIndex(option => clean(typeof option === "string" ? option : option?.name).toLocaleLowerCase("lt-LT") === meta.label.toLocaleLowerCase("lt-LT"));
        return idx < 0 ? "" : v?.options?.[idx] ?? v?.["option" + (idx+1)];
      }));
    }
    const keys = new Map();
    descriptions.forEach(d => d.specs.forEach((val,key) => {
      if (!keys.has(key)) keys.set(key, { label: val.label, count: 0 });
      keys.get(key).count++;
    }));
    const sorted = [...keys].sort((a,b) => b[1].count-a[1].count || a[1].label.localeCompare(b[1].label,"lt-LT")).slice(0,60);
    for (const [key, entry] of sorted) rows.push(cell(entry.label, (p,v,i) => descriptions[i].specs.get(key)?.value));
    return { rows, descriptions };
  }
  function makeHeaderCell(p) {
    const th = mk("th","kmcompare-product-heading");
    const image = imageOf(p);
    if (image) {
      const img = mk("img","kmcompare-image");
      img.src = image; img.alt = p.title || ""; img.loading = "lazy";
      th.appendChild(img);
    }
    const title = mk("a","kmcompare-title",p.title || p.handle);
    title.href = productUrl(p.handle);
    th.appendChild(title);
    const variants = p.variants || [];
    if (variants.length > 1) {
      const label = mk("label", "kmcompare-variant-label", "Pasirinkite variantą");
      const select = mk("select", "kmcompare-variant");
      select.setAttribute("aria-label", "Pasirinkite variantą: " + (p.title || ""));
      select.dataset.kmcompareVariantHandle = p.handle;
      const current = getVariant(p);
      variants.forEach(variant => {
        const option = mk("option", "", variantTitle(variant) + (variant.available ? "" : " – nėra"));
        option.value = String(variant.id);
        option.disabled = !variant.available;
        option.selected = String(variant.id) === String(current?.id);
        select.appendChild(option);
      });
      select.addEventListener("change", () => {
        variantsByHandle.set(p.handle, select.value);
        const scroll = dialog?.querySelector(".kmcompare-scroll");
        const scrollLeft = scroll?.scrollLeft || 0;
        const focusHandle = p.handle;
        renderProducts(currentProducts, scrollLeft, focusHandle);
      });
      label.appendChild(select);
      th.appendChild(label);
    }
    const variant = getVariant(p);
    const buy = mk("button", "kmcompare-buy", isRental(p,variant) ? "Peržiūrėti pasiūlymą" : (variant?.available ? "Į krepšelį" : "Negalima užsakyti"));
    buy.type = "button";
    buy.disabled = !isRental(p, variant) && !variant?.available;
    buy.addEventListener("click", () => addProduct(p, buy));
    th.appendChild(buy);
    const remove = mk("button", "kmcompare-remove", "Pašalinti");
    remove.type = "button";
    remove.addEventListener("click", () => {
      selected = selected.filter(h => h !== p.handle);
      variantsByHandle.delete(p.handle);
      currentProducts = currentProducts.filter(x => x.handle !== p.handle);
      save(); renderTray(); updateButtons();
      if (!selected.length) { dialog.close(); return; }
      renderProducts(currentProducts);
    });
    th.appendChild(remove);
    return th;
  }
  let currentProducts = [];
  function renderProducts(products, desiredScroll = 0, focusHandle = null) {
    const scroll = dialog?.querySelector(".kmcompare-scroll");
    if (!scroll) return;
    const { rows, descriptions } = rowsFor(products);
    const table = mk("table","kmcompare-table");
    const head = mk("thead"), header = mk("tr");
    header.appendChild(mk("th","","Savybė"));
    products.forEach(p => header.appendChild(makeHeaderCell(p)));
    head.appendChild(header); table.appendChild(head);
    const body = mk("tbody");
    const appendRow = (label, values, makeNode = null) => {
      const comparable = values.map(value => clean(value).toLocaleLowerCase("lt-LT"));
      const different = new Set(comparable).size > 1;
      if (onlyDifferences && !different) return;
      const tr = mk("tr", different ? "kmcompare-different" : "");
      tr.appendChild(mk("th","",label));
      values.forEach((value,i) => {
        const td = mk("td");
        if (makeNode) td.appendChild(makeNode(value,i));
        else td.textContent = value;
        tr.appendChild(td);
      });
      body.appendChild(tr);
    };
    for (const row of rows.slice(0,9)) appendRow(row.label,row.values);
    appendRow("Aprašymas",descriptions.map(d => d.text),value => detailsContent(value));
    if (rows.length > 9) {
      const group = mk("tr", "kmcompare-section-row");
      const th = mk("th","","Techninės savybės ir pasirinkimai");
      th.colSpan = products.length + 1; group.appendChild(th); body.appendChild(group);
    }
    for (const row of rows.slice(9)) appendRow(row.label,row.values);
    if (!body.children.length) {
      const tr = mk("tr"),td=mk("td","","Skirtumų nerasta.");
      td.colSpan = products.length+1;tr.appendChild(td);body.appendChild(tr);
    }
    table.appendChild(body);
    scroll.replaceChildren(table);
    scroll.scrollLeft = desiredScroll;
    if (focusHandle) {
      const target = [...scroll.querySelectorAll(".kmcompare-variant")].find(input => input.dataset.kmcompareVariantHandle === focusHandle);
      target?.focus({ preventScroll: true });
    }
  }
  async function openCompare() {
    if (!selected.length) return;
    const serial = ++loadingSerial, handles = selected.slice(), modal = getDialog();
    modal.replaceChildren();
    const top = mk("div","kmcompare-head"), title = mk("h2","","Prekių palyginimas");
    const close = mk("button","kmcompare-close","×");
    close.type = "button"; close.setAttribute("aria-label","Uždaryti");
    close.addEventListener("click",()=>modal.close());
    top.append(title,close); modal.appendChild(top);
    const loading = mk("p","kmcompare-help","Įkeliami prekių aprašymai ir savybės…");
    modal.appendChild(loading);
    if (!modal.open) modal.showModal();
    const results = await Promise.all(handles.map(loadProduct));
    if (!modal.open || serial !== loadingSerial || selected.join("|") !== handles.join("|")) return;
    loading.remove();
    currentProducts = results.filter(Boolean);
    if (!currentProducts.length) {
      modal.appendChild(mk("p","kmcompare-error","Prekių duomenų nepavyko įkelti. Bandykite vėliau.")); return;
    }
    if (currentProducts.length !== results.length) modal.appendChild(mk("p","kmcompare-error","Kai kurių prekių duomenys laikinai nepasiekiami."));
    const controls = mk("div","kmcompare-controls");
    controls.appendChild(mk("p","kmcompare-help","Pasirinkite variantą, palyginkite savybes arba įdėkite prekę tiesiai į krepšelį."));
    const label = mk("label","kmcompare-diff-label");
    const checkbox = mk("input");
    checkbox.type = "checkbox"; checkbox.checked = onlyDifferences;
    checkbox.addEventListener("change",() => {
      onlyDifferences = checkbox.checked;
      renderProducts(currentProducts,modal.querySelector(".kmcompare-scroll")?.scrollLeft || 0);
    });
    label.append(checkbox,document.createTextNode(" Rodyti tik skirtumus"));
    controls.appendChild(label); modal.appendChild(controls);
    modal.appendChild(mk("div","kmcompare-scroll"));
    renderProducts(currentProducts);
  }
  function init() {
    renderTray(); scanCards();
    const observer = new MutationObserver(records => {
      if (records.some(record => record.addedNodes.length)) {
        clearTimeout(timeout);
        timeout = setTimeout(scanCards,160);
      }
    });
    observer.observe(document.body,{ childList:true, subtree:true });
    document.addEventListener("shopify:section:load",scanCards);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded",init,{once:true});
  else init();
})();